import { TextField as MuiTextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import PropTypes from "prop-types";

const TextField = ({ name, label, required, type = "text", disabled, ...rest }) => {
  const { control } = useFormContext();

  return <Controller
    name={name}
    control={control}
    render={({ field, fieldState }) => (
      <MuiTextField
        {...field}
        label={label}
        variant="outlined"
        fullWidth
        type={type}
        error={!!fieldState.error}
        helperText={fieldState.error?.message}
        required={!!required}
        disabled={!!disabled}
        {...rest}
      />
    )}
  />;
};

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  type: PropTypes.string,
  disabled: PropTypes.bool,
};

export default TextField;
